import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureCards from './components/FeatureCards';
import AboutSection from './components/AboutSection';
import WhyChooseSection from './components/WhyChooseSection';
import SEOArticles from './components/SEOArticles';
import CTASection from './components/CTASection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://oopbuy.cam';

export default function Home() {
  return (
    <>
      <SEOHead
        title="OOPBuy Spreadsheet – Shopping List & Product Guide 2026"
        description="Find the latest OOPBuy spreadsheet with 1000+ curated products, price comparison, and shipping insights. The most updated shopping list guide for smart buyers in 2026."
        keywords="oopbuy spreadsheet, spreadsheet shopping list, oopbuy guide, agent spreadsheet 2026, product shopping guide"
        canonicalUrl={`${SITE_URL}/`}
        ogTitle="OOPBuy Spreadsheet – Shopping List & Product Guide 2026"
        ogDescription="Find the latest OOPBuy spreadsheet with 1000+ curated products, price comparison, and shipping insights."
        ogUrl={`${SITE_URL}/`}
        ogImage="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20curated%20fashion%20items%20including%20sneakers%20hoodie%20bag%20and%20accessories%20arranged%20on%20warm%20cream%20linen%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20minimalist%20style%2C%20clean%20modern%20aesthetic%2C%20no%20text%20no%20logos%2C%20elevated%20composition%2C%20creamy%20neutral%20tones&width=1200&height=630&seq=og-homepage-v1&orientation=landscape"
        ogType="website"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'OOPBuy Spreadsheet – Shopping List & Product Guide 2026',
          description: 'Find the latest OOPBuy spreadsheet with 1000+ curated products, price comparison, and shipping insights. The most updated shopping list guide for smart buyers in 2026.',
          url: `${SITE_URL}/`,
          about: {
            '@type': 'Organization',
            name: 'OOPBuy Spreadsheet',
            url: SITE_URL,
            description: 'Curated shopping lists and product guides updated weekly.',
          },
          mainEntity: {
            '@type': 'ItemList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
              { '@type': 'ListItem', position: 2, name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
              { '@type': 'ListItem', position: 3, name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
              { '@type': 'ListItem', position: 4, name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
              { '@type': 'ListItem', position: 5, name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
            ],
          },
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeatureCards />
        <AboutSection />
        <WhyChooseSection />
        <SEOArticles />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}